import { render, staticRenderFns } from "./sidebarSection.vue?vue&type=template&id=1dd589b2"
import script from "./sidebarSection.vue?vue&type=script&lang=js"
export * from "./sidebarSection.vue?vue&type=script&lang=js"
import style0 from "./sidebarSection.vue?vue&type=style&index=0&id=1dd589b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports